import styled from 'styled-components/macro';
import React from 'react';
import { Col, Row, Collapse, List } from 'antd';
import Description from 'components/Description/Description';

const Panel = Collapse.Panel;

const StyledSubItemText = styled.p`
  font-size: 14px;
  margin-bottom: 0;
`;
const StyledParagraph = styled.p`
  color: ${props => props.theme.color.darkGrey};
  font-size: 18px;
  margin-bottom: 0;
`;
const StyledItemCount = styled(StyledParagraph)`
  width: 16.6666667%;
  margin-left: 4px;
  @media (min-width: 768px) {
    width: 33.333333%;
  }
`;
const SubItem = ({ title, quantity }) => {
  return (
    <>
      <Row type="flex">
        <Col span={16}>
          <StyledSubItemText style={{ paddingLeft: '18px' }}>{title}</StyledSubItemText>
        </Col>
        <Col span={8}>
          <StyledSubItemText>{quantity}</StyledSubItemText>
        </Col>
      </Row>
    </>
  );
};

const PanelHeader = ({ headerChildren, extraChildren }) => {
  return (
    <Row gutter={16} align="middle">
      <Col span={12} md={18} style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
        <Description size="large" bold style={{ display: 'inline' }}>
          {headerChildren}
        </Description>
      </Col>
      <Col span={12} md={6} style={{ textAlign: 'right' }}> 
        <Description size="large" bold style={{ display: 'inline' }}>
          {extraChildren}
        </Description>
      </Col>
    </Row>
  );
};

const StyledListItem = styled(List.Item)`
  padding-left: 32px !important;
`;

const Root = styled.div`
  margin-bottom: 8px;
`;

const RenoCalculatorContent = ({ header, data, totalAmount }) => {
  return (
    <Root>
      <Collapse>
        <Panel
          header={
            <PanelHeader headerChildren={header} extraChildren={`RM ${totalAmount.toFixed(2)}`}>
              {header}
            </PanelHeader>
          }
          key={header}
        >
          <List
            itemLayout="horizontal"
            dataSource={data}
            renderItem={item => (
              <StyledListItem>
                <List.Item.Meta
                  title={<StyledParagraph>{item.label}</StyledParagraph>}
                  description={
                    item.subItems ? item.subItems.map(subItem => <SubItem title={subItem.label} quantity={subItem.quantity} />) : item.description
                  }
                />
                {!item.subItems && <StyledItemCount>{item.quantity}</StyledItemCount>}
              </StyledListItem>
            )}
          />
        </Panel>
      </Collapse>
    </Root>
  );
};

RenoCalculatorContent.defaultProps = {
  header: '',
  data: [],
  totalAmount: 0
};

export default RenoCalculatorContent;
